module.exports = __webpack_public_path__ + "img/kalashnikov.6d38c1b7.svg";